AccessController = App.loadClass 'admin::Angular/AccessController'

class exports.ManageUsersController extends AccessController
    constructor: (@scope, @transitions, @modal, @service, @window, @http) ->
        super('manage_users', @http)

        @scope.title = 'Manage Users'
        @scope.fullpage = true
        @scope.displayedCollection = []

        # Functions
        @scope.viewAccountInfo = @viewAccountInfo
        @scope.editContactInfo = @editContactInfo
        @scope.changeActivity = @changeActivity
        @scope.editRoles = @editRoles
        @scope.deleteUser = @deleteUser

        @loadUsers()

        @scope.refreshMeh = () =>
            angular.element(@window).trigger 'resize'
            return


    editRoles: (user) =>
        newscope = @scope.$new(true)
        newscope.user = user

        dlg = @modal.open
            scope: newscope
            windowClass: 'modal-width'
            templateUrl: 'backend/admin/new-tools/manage-users/edit-roles-layout'
            controller: 'Tools.Controllers.EditRolesController'
            resolve:
                'roles': ['Tools.Services.ManageUsersService', (service) =>
                    return service.editRoles(user.id)
                ]

    viewAccountInfo: (user) =>
        newscope = @scope.$new(true)
        newscope.user = user

        dlg = @modal.open
            scope: newscope
            windowClass: 'modal-width'
            templateUrl: 'backend/admin/new-tools/manage-users/view-account-info-layout'
            controller: 'Tools.Controllers.ViewAccountInfoController'
            resolve:
                'account': ['Tools.Services.ManageUsersService', (service) =>
                    return service.viewAccountInfo(user.id)
                ]


    editContactInfo: (user) =>
        dlg = @modal.open
            windowClass: 'modal-width'
            templateUrl: 'backend/admin/new-tools/manage-users/edit-contact-info-layout'
            controller: 'Tools.Controllers.EditContactInfoController'
            resolve:
                'contact': ['Tools.Services.ManageUsersService', (service) =>
                    return service.editContactInfo(user.id)
            ]

        dlg.result.then () =>
            @loadUsers()


    changeActivity: (id, activate) =>
        @service.changeActivity(id, activate).then (response) =>
            @setAlert(response)
            @loadUsers()


    deleteUser: (user) =>
        newscope = @scope.$new(true)
        newscope.user = user

        dlg = @modal.open
            scope: newscope
            windowClass: 'modal-width'
            templateUrl: 'backend/admin/new-tools/manage-users/delete-user-layout'
            controller: 'DialogController'

        dlg.result.then () =>
            @service.deleteUser(user.id).then (response) =>
                @setAlert(response)
                @loadUsers()


    loadUsers: () =>
        @loadScopeData @service.getUsers(), 'users'
            .then () =>
                angular.element(@window).trigger 'resize'
                true
